import { MenhirFamilyMemberType } from '@/common/integrations/menhir/employee/employee/employee.types';
import { MARKET, TMarket } from './markets';

export interface IKinship {
  value: MenhirFamilyMemberType;
  label: string;
}

export const determineKinships = (market: TMarket): IKinship[] => {
  if (market === MARKET.PT) {
    return [
      { value: 'spouse', label: 'general.kinship.spouse' },
      { value: 'child', label: 'general.kinship.child' },
    ];
  }
  if (market === MARKET.IT) {
    return [
      { value: 'spouse', label: 'general.kinship.spouse' },
      { value: 'child', label: 'general.kinship.child' },
      { value: 'sibling', label: 'general.kinship.sibling' },
      { value: 'parent', label: 'general.kinship.parent' },
      { value: 'parent-in-law', label: 'general.kinship.parent-in-law' },
      { value: 'sibling-in-law', label: 'general.kinship.sibling-in-law' },
      { value: 'grandparent', label: 'general.kinship.grandparent' },
      { value: 'civil-partner', label: 'general.kinship.civil-partner' },
    ];
  }
  if (market === MARKET.ES) {
    return [
      { value: 'spouse', label: 'general.kinship.spouse' },
      { value: 'child', label: 'general.kinship.child' },
      { value: 'civil-partner', label: 'general.kinship.civil-partner' },
    ];
  }

  return [];
};
